/**
 * APDEV - Cart Toast Notification System
 * Sistema di notifiche toast per azioni del carrello
 */

(function() {
  'use strict';

  // Configurazione del toast
  const TOAST_CONFIG = {
    duration: 3000, // durata in millisecondi
    position: 'center', // 'center', 'top', 'bottom'
    showQuantity: true,
    messages: {
      added: 'Prodotto aggiunto al carrello',
      removed: 'Prodotto rimosso dal carrello',
      updated: 'Carrello aggiornato'
    }
  };

  // Creo il container del toast se non esiste
  function apdevCreateToastContainer() {
    if (document.getElementById('apdev-toast-container')) {
      return;
    }

    const container = document.createElement('div');
    container.id = 'apdev-toast-container';
    container.setAttribute('aria-live', 'polite');
    container.setAttribute('aria-atomic', 'true');
    document.body.appendChild(container);
  }

  // Mostra il toast
  function apdevShowToast(message, quantity = null, type = 'success') {
    const container = document.getElementById('apdev-toast-container');
    
    const toast = document.createElement('div');
    toast.className = `apdev-toast apdev-toast--${type} apdev-toast--${TOAST_CONFIG.position}`;
    
    let content = `<div class="apdev-toast__content">`;
    
    // Icona in base al tipo
    if (type === 'success') {
      content += `
        <svg class="apdev-toast__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;
    } else if (type === 'info') {
      content += `
        <svg class="apdev-toast__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13 16H12V12H11M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;
    }
    
    content += `<span class="apdev-toast__message">${message}</span>`;
    
    if (TOAST_CONFIG.showQuantity && quantity !== null) {
      content += `<span class="apdev-toast__quantity">(${quantity > 0 ? '+' : ''}${quantity})</span>`;
    }
    
    content += `</div>`;
    toast.innerHTML = content;
    
    container.appendChild(toast);
    
    // Trigger animazione di ingresso
    setTimeout(() => {
      toast.classList.add('apdev-toast--visible');
    }, 10);
    
    // Rimozione automatica
    setTimeout(() => {
      toast.classList.remove('apdev-toast--visible');
      setTimeout(() => {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, 300);
    }, TOAST_CONFIG.duration);
  }

  // Intercetto i click sui pulsanti di incremento/decremento
  function apdevInitCartButtons() {
    document.addEventListener('click', function(e) {
      const addButton = e.target.closest('[data-add-quantity]');
      const removeButton = e.target.closest('[data-subtract-quantity]');
      const quickAddButton = e.target.closest('.product-item__quick-add');
      
      if (addButton) {
        // Prodotto aggiunto (pulsante + nella pagina prodotto)
        setTimeout(() => {
          apdevShowToast(TOAST_CONFIG.messages.added, 1, 'success');
        }, 100);
      } else if (removeButton) {
        // Prodotto rimosso (pulsante - nella pagina prodotto)
        setTimeout(() => {
          apdevShowToast(TOAST_CONFIG.messages.removed, -1, 'info');
        }, 100);
      } else if (quickAddButton) {
        // Pulsante "Aggiungi al carrello" nelle pagine collezione
        const quantityInCart = parseInt(quickAddButton.getAttribute('data-quantity-in-cart')) || 0;
        
        // Mostra il toast solo se il prodotto non è già nel carrello
        if (quantityInCart === 0) {
          setTimeout(() => {
            apdevShowToast(TOAST_CONFIG.messages.added, 1, 'success');
          }, 100);
        }
      }
    });
  }

  // Intercetto anche le chiamate AJAX al carrello (se presenti)
  function apdevInterceptCartAjax() {
    // Backup della funzione fetch originale
    const originalFetch = window.fetch;
    
    window.fetch = function(...args) {
      const url = args[0];
      
      return originalFetch.apply(this, args).then(response => {
        // Controllo se è una chiamata al carrello
        if (typeof url === 'string' && url.includes('/cart/')) {
          const clonedResponse = response.clone();
          
          // Determino il tipo di azione
          if (url.includes('/add') || url.includes('/change')) {
            clonedResponse.json().then(data => {
              if (data && !data.error) {
                //apdevShowToast(TOAST_CONFIG.messages.updated, null, 'success');
              }
            }).catch(() => {
              // Ignora errori di parsing JSON
            });
          }
        }
        
        return response;
      });
    };
  }

  // Inizializza quando il DOM è pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      apdevCreateToastContainer();
      apdevInitCartButtons();
      apdevInterceptCartAjax();
    });
  } else {
    apdevCreateToastContainer();
    apdevInitCartButtons();
    apdevInterceptCartAjax();
  }

})();